import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from '@/constants/auth';
import {
  ADDRESS_MAX_LENGTH,
  NAME_DATA_LENGTH,
  NAME_MAX_LENGTH,
} from '@/constants/common';
import {
  REGEX_EMAIL,
  REGEX_HAFT_WIDTH,
  REGEX_PASSWORD,
  REGEX_NUMBER,
  REGEX_PHONE_LENGTH,
  REGEX_SPACE,
  REGEX_SPECIAL_CHARACTER,
  REGEX_START_ZERO,
  NEGATIVE_NUMBER,
  DECIMAL_NUMBER,
  REGEX_FULL_WIDTH,
} from '@/constants/regex';
import i18n from '@/plugins/i18n';

export const require = (rule, value, callback) => {
  !value && callback(new Error(i18n.t('validate.require')));
};

export const required = (rule, value, callback) => {
  require(rule, value, callback);

  return callback();
};

export const sizePassword = (rule, value, callback) => {
  (value.length < PASSWORD_MIN_LENGTH || value.length > PASSWORD_MAX_LENGTH) &&
    callback(new Error(i18n.t('validate.sizePassword')));
};

export const spacePassword = (rule, value, callback) => {
  REGEX_SPACE.test(value) &&
    callback(new Error(i18n.t('validate.spacePassword')));
};

export const haftWithPassword = (rule, value, callback) => {
  !REGEX_PASSWORD.test(value) &&
    callback(new Error(i18n.t('validate.haftWithPassword')));
};

export const checkFullWidth = (rule, value, callback) => {
  REGEX_FULL_WIDTH.test(value) &&
    callback(new Error(i18n.t('validate.haftWithPassword')));
};

export const password = (rule, value, callback) => {
  require(rule, value, callback);
  value = typeof value === 'string' && value ? value.trim() : value;

  return callback();
};

export const name = (rule, value, callback) => {
  require(rule, value, callback);

  if (value.length > NAME_MAX_LENGTH) {
    return callback(new Error(i18n.t('validate.maxLength')));
  }

  value = typeof value === 'string' && value ? value.trim() : undefined;
  if (value === '') {
    return require(rule, value, callback);
  }
  return callback();
};

export const phone = (rule, value, callback) => {
  require(rule, value, callback);

  if (!REGEX_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.phoneFormat')));
  }

  if (!REGEX_START_ZERO.test(value)) {
    return callback(new Error(i18n.t('validate.startZero')));
  }

  if (!REGEX_PHONE_LENGTH.test(value)) {
    return callback(new Error(i18n.t('validate.phoneInvalidate')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const role = (rule, value, callback) => {
  require(rule, value, callback);

  if (value.length > NAME_MAX_LENGTH) {
    return callback(new Error(i18n.t('validate.maxLength')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const store = (rule, value, callback) => {
  require(rule, value, callback);

  return callback();
};

export const address = (rule, value, callback) => {
  require(rule, value, callback);

  if (value.length > ADDRESS_MAX_LENGTH) {
    return callback(new Error(i18n.t('validate.maxLengthAddress')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const email = (rule, value, callback) => {
  if (!value) {
    return callback();
  }

  spacePassword(rule, value, callback);

  if (REGEX_SPECIAL_CHARACTER.test(value)) {
    return callback(new Error(i18n.t('validate.specialEmail')));
  }

  if (!REGEX_HAFT_WIDTH.test(value)) {
    return callback(new Error(i18n.t('validate.requireHaftWidth')));
  }

  if (!REGEX_EMAIL.test(value)) {
    return callback(new Error(i18n.t('validate.emailInvalidate')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const maxName225 = (rule, value, callback) => {
  require(rule, value, callback);

  if (value) {
    if (value.length > NAME_DATA_LENGTH) {
      return callback(new Error(i18n.t('validate.max255')));
    }

    value = typeof value === 'string' && value ? value.trim() : undefined;
    if (value === '') {
      return require(rule, value, callback);
    }
    return callback();
  }
};

export const quantityProduct = (rule, value, callback) => {
  require(rule, value, callback);

  if (REGEX_SPECIAL_CHARACTER.test(value)) {
    return callback(new Error(i18n.t('validate.specialNumber')));
  }

  if (NEGATIVE_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.negativeNumber')));
  }

  if (!REGEX_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.formatNumber')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const buyPriceProduct = (rule, value, callback) => {
  require(rule, value, callback);

  if (NEGATIVE_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.negativeNumber')));
  }

  if (DECIMAL_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.decimalNumber')));
  }

  if (!REGEX_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.phoneFormat')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const sellPriceProduct = (rule, value, callback) => {
  if (!value) {
    return callback();
  }

  if (NEGATIVE_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.negativeNumber')));
  }

  if (DECIMAL_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.decimalNumber')));
  }

  if (!REGEX_NUMBER.test(value)) {
    return callback(new Error(i18n.t('validate.phoneFormat')));
  }

  value = typeof value === 'string' && value ? value.trim() : value;
  return callback();
};

export const textProduct = (rule, value, callback) => {
  if (!value) {
    return callback();
  } else {
    if (value.length > NAME_DATA_LENGTH) {
      return callback(new Error(i18n.t('validate.max255')));
    }

    value = typeof value === 'string' && value ? value.trim() : value;
    return callback();
  }
};
